import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  AiFillCheckSquare,
  AiFillCloseCircle,
  AiFillDelete,
  AiFillStar,
  AiOutlineComment,
} from "react-icons/ai";
import Loading from "../components/Loading";
import { AnimatePresence, motion } from "framer-motion";
import { box1, container } from "../data/anim";
import { BsThreeDots } from "react-icons/bs";
import { deleteArticle } from "../actions/articleActions";
const Articles = ({ articles, owner }) => {
  const [handleSave, setHandleSave] = useState(false);
  const [Articles, setArticles] = useState(articles);
  const handleDelete = async (id) => {
    await deleteArticle(id);
    const newData = Articles.filter((data) => data._id !== id);
    setArticles([...newData]);
    setHandleSave(false);
  };

  console.log(articles);
  console.log(Articles);
  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="articles-container"
    >
      {articles
        .slice()
        .reverse()
        .map((data) => {
          const {
            name,
            averageRating,
            _id,
            summary,
            thumbnail,
            comments,
            title,
            createdAt,
          } = data;
          return (
            <AnimatePresence key={_id}>
              <motion.div variants={box1} className="article-container">
                {owner &&
                  (!handleSave ? (
                    <div className="three-dots-container">
                      <button
                        className="delete"
                        onClick={() => setHandleSave(true)}
                      >
                        <AiFillDelete />
                      </button>
                    </div>
                  ) : (
                    <div className="three-dots-container">
                      <button
                        className="close"
                        onClick={() => setHandleSave(false)}
                      >
                        <AiFillCloseCircle />
                      </button>
                      <button
                        className="warning"
                        onClick={() => handleDelete(_id)}
                      >
                        <AiFillCheckSquare />
                      </button>
                    </div>
                  ))}
                <a href={`/article/${name}`} className="ratings">
                  {averageRating ? (
                    <div className="rating-container">
                      <AiFillStar /> {averageRating}
                    </div>
                  ) : (
                    <div className="rating-container">
                      <AiFillStar /> 0
                    </div>
                  )}
                </a>
                <div className="article-image">
                  <img src={thumbnail} alt="pic" />
                </div>
                <div className="article-content">
                  <a href={`/article/${name}`} className="article-btn">
                    Learn more
                  </a>
                  <div className="article-name">
                    <h2 style={{ wordBreak: "break-word" }}>
                      {title.length > 40 ? ` ${title.substr(0, 38)}...` : title}
                    </h2>
                  </div>
                  <div className="text">
                    <p>{`${summary.substr(0, 80)}...`}</p>
                  </div>
                  <div className="row">
                    <div>{moment(createdAt).format("LL")}</div>
                    <a href={`/article/${name}`} className="comment-number">
                      <AiOutlineComment />
                      {comments ? comments.length : "0"}
                    </a>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          );
        })}
    </motion.div>
  );
};

export default Articles;
